import React, { useRef } from 'react';
import { IconBrandInstagram, IconFingerprint, IconHash, IconMicrophone, IconUsers } from '@tabler/icons-react';
import { Anchor, Glow, Pill, Core, Wires, Sparks, travel, flare, blink, charge, ambience, entrance, useSceneAnimation, gsap } from '../../../../../../../../components/Scene';
import './styles.scss';

// Vertical: the creator's profile is read by the core, which finds what makes it
// theirs — the topics, the voice and the audience — one trait at a time. Drawn in
// the 75–325 band of the stage.
const TRAITS = [
  { id: 'topics', x: 78, y: 262, tone: 'cool', icon: IconHash, label: 'artTraitTopics' },
  { id: 'voice', x: 180, y: 306, tone: 'violet', icon: IconMicrophone, label: 'artTraitVoice' },
  { id: 'audience', x: 282, y: 262, tone: 'warm', icon: IconUsers, label: 'artTraitAudience' },
];
const WIRES = [
  { id: 'profile', tone: 'warm', d: 'M180 129 V151', joints: [[180, 129], [180, 151]] },
  { id: 'topics', tone: 'cool', d: 'M164 209 C164 234 78 228 78 246', joints: [[164, 209], [78, 246]] },
  { id: 'voice', tone: 'violet', d: 'M180 209 V290', joints: [[180, 209], [180, 290]] },
  { id: 'audience', tone: 'warm', d: 'M196 209 C196 234 282 228 282 246', joints: [[196, 209], [282, 246]] },
];
const SPARKS = [[140, 150], [220, 146], [150, 226], [210, 230], [116, 196], [244, 192]];
const STEP = 1.05;

function build(q, { still }) {
  if (still) {
    gsap.set(q('[data-ring="voice"]'), { opacity: 0.9 });
    return;
  }
  ambience(q);
  const intro = entrance(q);
  const loop = gsap.timeline({ repeat: -1, repeatDelay: 1.2, delay: intro.duration() - 0.2 });
  flare(loop, q, 'profile', 0, 0.5);
  blink(loop, q, ['profile-0'], 0.1);
  travel(loop, q, 'profile', 0.12, 0.55);
  blink(loop, q, ['profile-1'], 0.65);
  TRAITS.forEach(({ id }, i) => {
    const at = 0.7 + i * STEP;
    charge(loop, q, at);
    blink(loop, q, [`${id}-0`], at + 0.08);
    travel(loop, q, id, at + 0.1, 0.6);
    blink(loop, q, [`${id}-1`], at + 0.68);
    flare(loop, q, id, at + 0.7, 0.9);
  });
}

export default function IdentityScene({ t }) {
  const stage = useRef(null);
  useSceneAnimation(stage, build);
  return <div className="studio-feature-art__stage" ref={stage}>
    <Glow x={180} y={180} tone="violet" size={220} />
    <Glow x={180} y={104} tone="warm" size={140} />
    <Glow x={180} y={296} tone="cool" size={160} />
    <Sparks points={SPARKS} />
    <Wires wires={WIRES} />
    <Anchor x={180} y={104}>
      <div className="studio-feature-art__card studio-landing-art__profile is-warm" data-enter>
        <span className="studio-landing-art__avatar"><IconBrandInstagram aria-hidden="true" /></span>
        <span className="studio-landing-art__profile-text">
          <span className="studio-landing-art__handle">{t('artHandle')}</span>
          <span className="studio-landing-art__network">Instagram</span>
        </span>
        <span className="studio-feature-art__ring" data-ring="profile" />
      </div>
    </Anchor>
    <Anchor x={180} y={180}><Core icon={IconFingerprint} /></Anchor>
    {TRAITS.map(({ id, x, y, tone, icon, label }) => <Anchor key={id} x={x} y={y}><Pill id={id} tone={tone} icon={icon}>{t(label)}</Pill></Anchor>)}
  </div>;
}
